export default "__VITE_ASSET__CBhaXByh__"